import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import AnimatedBackground from './components/AnimatedBackground';
import ProductPage from './components/pages/ProductPage';
import PortfolioPage from './components/pages/PortfolioPage';
import ContactPage from './components/pages/ContactPage';
import IndexPage from './components/pages/index';
import ScrollToTop from './components/ScrollUp';
import Footer from './components/Footer';
import ScrollToTopOnRouteChange from './components/ScrollToTopOnRouteChange';

function App() {
  return (
    <Router>
      <ScrollToTopOnRouteChange />
      <div style={{ position: 'relative', overflow: 'hidden', zIndex: 0 }}>
        <Header />
        <AnimatedBackground />
        <ScrollToTop />
        <div style={{ position: 'relative', zIndex: 1 }}>
          <Routes>
            <Route path="/" element={<IndexPage />} />
            <Route path="/product" element={<ProductPage />} />
            <Route path="/usecases" element={<PortfolioPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
          <Footer />
        </div>
      </div>
    </Router>
  );
}

export default App;
